const isEmpty = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;
if (window.sizeChartsRelentless && isEmpty(window.sizeChartsRelentless.metafield)) {
    const sizeChartButtons = document.querySelectorAll('button.scr-open-size-chart');
    sizeChartButtons.forEach(function (button) {
        button.style.display = 'none';
    });
}